import { Divider, styled } from '@mui/material';
interface AccentDividerProps {
    width?: number | string;
    borderWidht?: string;
}
const accentColor = 'rgba(17, 42, 70)';
const CustomDivider = styled(Divider)(({ theme }) => ({
    padding: theme.spacing(0),
    marginBottom: 16,
    height: theme.spacing(0),
    minHeight: theme.spacing(0),
    maxHeight: theme.spacing(0),
    backgroundColor: accentColor,
    opacity: 0.4
}));
const AccentDivider = ({ width = 75, borderWidht = '2px' }: AccentDividerProps) => {
    return <CustomDivider sx={{ border: `${borderWidht} solid ${accentColor};`, width: width }} />;
};

export default AccentDivider;
